import {BiBriefcase} from "react-icons/bi";
import {FaGraduationCap} from "react-icons/fa";
import {FaSchool} from "react-icons/fa";

const homeConfig = {
    blogabout: {
        start: "\"Never let formal education get in the way of your learning.\" ~Mark Twain.",
        exit: "Courses I've done or aiming to. If you have any recommendation regarding useful and interesting courses feel free to send it."
    },
    greeting:
        <h1 className="heading">
            Hi there! I'm <strong className="main-name"> Apostolos Karvelas</strong>
        </h1>,
    titles: [
        "Data Scientist",
        "Artificial Intelligence Student",
        "Machine Learning Student"
    ],
    about: {
        start: "Aspiring, motivated, and curious computer science student with two specializations in software development and data science. Passionate about building deep learning models to analyze data and find patterns and predictions. Some of my skills include machine learning, low-level programming, and problem-solving.",
        exit: "I'm currently learning Python, R, Big Data tools, SQL databases and more, " +
            "with a deep interest in artificial intelligence & machine learning."
    },
    workTimeline: [
        {
            id: "work-3",
            title: "Data Scientist Intern",
            company: "INTRASOFT International",
            description: "Learning how to use powerful tools such as Apache Hive, Spark, Flume, and Kafka to manipulate and extract useful information from available data",
            date: "2022-present",
            icon: <BiBriefcase/>,
            tags: []
        },
        {
            id: "work-2",
            title: "Computer Science Student",
            company: "University of Athens",
            description: "Specialization in both computer science and data science. Working on my thesis in deep learning under the guidance of Dimitris Goynopoylos.",
            date: "2018-present",
            icon: <FaGraduationCap/>,
            tags: []
        },
        {
            id: "work-1",
            title: "High School Student",
            company: "6th High School Acharnes",
            description: "GPA: 19.6/20 (in top 2% of class)",
            date: "2015-2018",
            icon: <FaSchool/>,
            tags: []
        }
    ]
}


export default homeConfig